import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription, Subject } from 'rxjs';
import { map, concatMap, switchMap, tap, filter } from 'rxjs/operators';

import { Table } from 'primeng/table';
import { FilterService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { Product, ProductInfo } from 'src/app/shared/product'

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { DocTypes } from 'src/app/shared/doc-list-entry';

class productOfCustomer extends Product {
  DOCSCOUNT?: number;
  TOTALQNTY?: number;
}

@Component({
  selector: 'app-list-products-of-customer',
  templateUrl: './list-products-of-customer.component.html',
  styleUrl: './list-products-of-customer.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ListProductsOfCustomerComponent implements OnInit, OnDestroy, OnChanges {
  private globalSettinsData: GlobalSettingsData;

  saveStateKey: string = 'list-products-of-customer';

  @Input() clientId: number = 0;

  rows: number = 20;
  totalRecords: number = 0;

  productInfo: productOfCustomer[] = [];
  selectedRow: productOfCustomer = null;

  //@ViewChild('inTransitTable') inTransitTable: Table;

  private _productQuery: Subscription;
  private _prodRowQuery: Subscription;

  private listOptions$ = new Subject < { clientId: number, fromDate: Date, toDate: Date, docTypes: number[] } > ();

  selectAllTypes: boolean = false;
  selectedDocTypes: DocTypes[];
  docTypes: DocTypes[];

  filterDate: Date[] = [];
  fromDate: Date = null;
  toDate: Date = null;

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private messageService: MessageService,
    private filterService: FilterService,
    private cliApi: ClientApiService,
    private docApi: DocumentApiService  
  ) {

    let todate = new Date();
    this.toDate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate(), 23, 59, 59); // End of current day
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ListProductsOfCustomerComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ListProductsOfCustomerComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ListProductsOfCustomerComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'clientId':
          this.listOptions$.next({
            clientId: this.clientId,
            fromDate: this.fromDate,
            toDate: this.toDate,
            docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
          });

          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ListProductsOfCustomerComponent in ngOnDestroy')

    if (this.saveStateKey != '') {
      localStorage.setItem(this.saveStateKey + '-fromDate', JSON.stringify(this.fromDate));
      localStorage.setItem(this.saveStateKey + '-toDate', JSON.stringify(this.toDate));
      localStorage.setItem(this.saveStateKey + '-docTypes', JSON.stringify(this.selectedDocTypes));
    }

    if (this._productQuery) { this._productQuery.unsubscribe(); }

    if (this._prodRowQuery) { this._prodRowQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** ListProductsOfCustomerComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    if (this.saveStateKey != '') {
      try {
        const fromDateStr = localStorage.getItem(this.saveStateKey + '-fromDate');
        if (fromDateStr) {
          this.fromDate = new Date(JSON.parse(fromDateStr));
        }
        const toDateStr = localStorage.getItem(this.saveStateKey + '-toDate');
        if (toDateStr) {
          this.toDate = new Date(JSON.parse(toDateStr));
        }
        const docTypesStr = localStorage.getItem(this.saveStateKey + '-docTypes');
        if (docTypesStr) {
          this.selectedDocTypes = JSON.parse(docTypesStr);
        }
      } catch (e) {
        console.error('*** ListProductsOfCustomerComponent ngOnInit: Error in restoring state from localStorage: ' + e);
        this.toDate = new Date();
        this.fromDate = null;
        this.selectedDocTypes = [];
      }
    }

    this.docApi.getDocTypes().subscribe(
      {
        next: types => {
          this.docTypes = types;
        },
        error: err => console.error('*** ListProductsOfCustomerComponent ngOnInit getDocTypes error: ' + err)
      }
    );


    this._productQuery = this.listOptions$
      .pipe(
        tap(options => console.log('*** ListProductsOfCustomerComponent onInitTableLoads options: ' + JSON.stringify(options))),

      // Check whether we have mainId for the client
      // And pull it out

        concatMap(options => this.cliApi.getMainIdByClientId(options.clientId).pipe(
          filter(mainId => (mainId != null) && (mainId.length > 0)),
          map(mainId => mainId[0]),
          map(mainId => ({ ...options, clientId: mainId.CLIID }))
        )),

        switchMap(options => {

          let queryOptions: any[] = []
          queryOptions.push({ mode: 'DOCTYPE', value: options.docTypes || [] });
          queryOptions.push({ mode: 'DOCFIELD', fieldName: 'DOCMANCLIID', valueType: 'number', operMode: 'equal', fieldValue: this.globalSettinsData.mainCompanyId.toString() });
          queryOptions.push({ mode: 'DOCFIELD', fieldName: 'DOCCLIENTSID', valueType: 'number', operMode: 'equal', fieldValue: options.clientId.toString() });
          if (options.fromDate) {
            queryOptions.push({ mode: 'DOCFIELD', fieldName: 'DOCDATE', valueType: 'date', operMode: 'after', fieldValue: options.fromDate.toISOString() });
          }
          if (options.toDate) {
            queryOptions.push({ mode: 'DOCFIELD', fieldName: 'DOCDATE', valueType: 'date', operMode: 'before', fieldValue: options.toDate.toISOString() });
          }
          console.log('*** ListProductsOfCustomerComponent onInitTableLoads queryOptions: ' + JSON.stringify(queryOptions));

          return this.prodApi.findProductsInDocumentsByParameters(queryOptions);
        }),

        map(data => {
          this.productInfo = data;
          this.totalRecords = data.length;
          return data;
        }
      ))
      .subscribe({
        next: data => ( console.log('*** ListProductsOfCustomerComponent onInitTableLoads records: ' + this.totalRecords)), 
        error: err => console.error('*** ListProductsOfCustomerComponent onInitTableLoads error: ' + err)
      });

    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  clearOrResetTableFilter(event) {
    console.log('*** ListProductsOfCustomerComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.selectedRow = null;

    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** ListProductsOfCustomerComponent onExportData: ')

    import("xlsx").then(xlsx => {

      //environment.production || console.table(this.inTransitList);

      //const exportData: any =
      //  this.inTransitList.map(e => ({

      //    'Код товара': e.PRODCODE,
      //    'В транзите': e.PRODWAITQNTY,
      //    'Заказано': e.DOCITEMQTY,
      //    'Отгрузка': e.DOCEXPDATE,
      //    'Ожидается': e.DOCVALDATE,
      //    'Документ': e.DOCNAMESTR,
      //    'Дата': e.DOCDATE,
      //    'Поставщик': e.VENDORNAME,
      //    'Получатель': e.LOCALCOMP,
      //    'Примечание получателя': e.DOCNOTE1,
      //    'Примечание поставщика': e.DOCNOTE2,
      // }));

    //  const worksheet = xlsx.utils.json_to_sheet(exportData || []);
    //  const workbook = { Sheets: { products: worksheet }, SheetNames: ['products'] };

    //  const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

    //  this.saveAsExcelFile(excelBuffer, "products");
    });
  }
  onDocTypeChange(event) {
    console.log('*** ListProductsOfCustomerComponent onDocTypeChange: ' + JSON.stringify(event));
    //environment.production || console.log('*** DocumentsComponent onDocTypeChange: ' + JSON.stringify(this.selectedDocTypes));

    environment.production || console.table(this.selectedDocTypes);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onAllDocTypeChange(event) {
    console.log('*** ListProductsOfCustomerComponent onAllDocTypeChange: ' + JSON.stringify(event));
    //environment.production || console.log('*** DocumentsComponent onAllDocTypeChange: ' + JSON.stringify(this.selectedDocTypes));

    this.selectAllTypes = event.checked;
    this.selectedDocTypes = this.selectAllTypes ? [...this.docTypes] : [];

    environment.production || console.table(this.selectedDocTypes);
    //  this.table.filter(this.selectedDocTypes, 'DOCTYPEID', 'in');
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeChangeFrom(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeChange: ' + JSON.stringify(event));
    //console.log('*** ListProductsOfCustomerComponent onDateRangeChange: ' + JSON.stringify(this.filterDate));
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeClearFrom(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onTodayClickFrom(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeClear: ' + event.value);

    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeChange(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeChange: ' + JSON.stringify(event));
    //console.log('*** ListProductsOfCustomerComponent onDateRangeChange: ' + JSON.stringify(this.filterDate));
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onDateRangeClear(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

  onTodayClick(event) {
    //console.log('*** ListProductsOfCustomerComponent onDateRangeClear: ' + event.value);
    this.listOptions$.next({
      clientId: this.clientId,
      fromDate: this.fromDate,
      toDate: this.toDate,
      docTypes: this.selectedDocTypes ? this.selectedDocTypes.map(dt => dt.DOCTYPEID) : []
    });
  }

}
